import React from 'react';

import dayjs from 'utils/dayjsConfig';

import { formatAtsSnapshot, getOosMechanismLabel, getOosStatusLabel } from './oosLogLabels';

/**
 * @param {Object} props
 * @param {Array<Object>} props.events
 */
export function OosLogTable({ events }) {
    return (
        <table aria-label="OOS log events" className="w-full border-collapse text-sm">
            <thead>
                <tr className="border-b bg-muted/40 text-left">
                    <th className="p-2" scope="col">
                        Timestamp
                    </th>
                    <th className="p-2" scope="col">
                        SKU / Item
                    </th>
                    <th className="p-2" scope="col">
                        Mechanism
                    </th>
                    <th className="p-2" scope="col">
                        Resulting Status
                    </th>
                    <th className="p-2" scope="col">
                        Facility
                    </th>
                    <th className="p-2" scope="col">
                        Company Source
                    </th>
                    <th className="p-2" scope="col">
                        Pack Group
                    </th>
                    <th className="p-2" scope="col">
                        Pack Line
                    </th>
                    <th className="p-2" scope="col">
                        Details
                    </th>
                    <th className="p-2" scope="col">
                        ATS Snapshot
                    </th>
                    <th className="p-2" scope="col">
                        Auth User
                    </th>
                </tr>
            </thead>
            <tbody>
                {events.map((event) => {
                    const skuItemLabel = `${event.externalSku} — ${event.itemName}`;
                    const mechanismLabel = getOosMechanismLabel(event.oosType);
                    const statusLabel = getOosStatusLabel(event.status);
                    const packLineLabel =
                        event.packLineNumber === null || event.packLineNumber === undefined
                            ? '—'
                            : String(event.packLineNumber);
                    const detailsLabel = event.details || '—';
                    const atsLabel = formatAtsSnapshot(event.atsSnapshot);
                    const parsedTimestamp = dayjs(event.timestamp);
                    const timestampLabel = parsedTimestamp.isValid()
                        ? parsedTimestamp.format('YYYY-MM-DD HH:mm:ss')
                        : event.timestamp;

                    return (
                        <tr key={event.id} className="border-b align-top">
                            <td className="p-2 whitespace-nowrap">{timestampLabel}</td>
                            <td className="p-2">{skuItemLabel}</td>
                            <td className="p-2">{mechanismLabel}</td>
                            <td className="p-2">{statusLabel}</td>
                            <td className="p-2">{event.facilityName}</td>
                            <td className="p-2">{event.companySourceName}</td>
                            <td className="p-2">{event.packGroupName}</td>
                            <td className="p-2">{packLineLabel}</td>
                            <td className="p-2">{detailsLabel}</td>
                            <td className="p-2">{atsLabel}</td>
                            <td className="p-2">{event.authUser}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
